import React from "react";
import { Navigate } from "react-router-dom";
import { isLoggedIn } from "./auth";

function ProtectedRoute({ children, authReady = true }) {
  if (!authReady) {
    return null;
  }

  if (!isLoggedIn()) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;